class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.content =
      this.mainDetailsToggle.querySelector("summary").nextElementSibling;

    this.mainDetailsToggle.addEventListener(
      "focusout",
      this.onFocusOut.bind(this)
    );
    this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
  }

  onFocusOut(event) {
    // if the focus has left the header
    // and the menu is open, close it
    // debugger;
    // console.log(
    //   "onFocusOut",
    //   event,
    //   event.relatedTarget,
    //   event.relatedTarget &&
    //     event.relatedTarget.closest(".header-wrapper") === null,
    //   this.mainDetailsToggle.open
    // );
    if (event.relatedTarget) {
      if(event.relatedTarget.classList.contains("mega-menu__content"))return;
      if (event.relatedTarget.hasAttribute("href")) {
        
        location.href = event.relatedTarget.getAttribute("href");
        this.close(true);
        return;
      }else if (
        event.relatedTarget.closest(".header-wrapper") === null &&
        this.mainDetailsToggle.open
      ) {
        // console.log(
        //   "focus out",
        //   this.mainDetailsToggle,
        //   event.relatedTarget,
        //   event.relatedTarget.closest(".header-wrapper")
        // );

        this.close(true);
      } else {
        // console.log(
        //   "focus out into header",
        //   this.mainDetailsToggle,
        //   event.relatedTarget,
        //   event.currentTarget,
        //   event.relatedTarget === event.target,
        //   event.relatedTarget?.closest(".header-wrapper")
        // );
        this.close(false);
      }
    }
  }

  onToggle(event) {
    // console.log("toggle", event);
    if (event.relatedTarget?.closest(".header-wrapper")) return;
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute("open")) {
      document.body.classList.add("menu-open");
      this.animations.forEach((animation) => animation.play());
    } else {
      document.body.classList.remove("menu-open");
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close(closeMenu = true) {
    // console.log("close", closeMenu);
    if (closeMenu) document.body.classList.remove("menu-open");
    this.mainDetailsToggle.removeAttribute("open");
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    // debugger;
    return true;
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector(".header-wrapper");
  }

  onToggle() {
    // console.log("toggle", this.header);
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    document.querySelectorAll(".mega-menu").forEach((menu) => {
      if (menu != this.mainDetailsToggle) menu.removeAttribute("open");
    });

    if (
      document.documentElement.style.getPropertyValue(
        "--header-bottom-position-desktop"
      ) !== ""
    )
      return;
    document.documentElement.style.setProperty(
      "--header-bottom-position-desktop",
      "41px"
    );
    // `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
  }
}

customElements.define("header-menu", HeaderMenu);
